import all from './all';
import items from './items';
import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';

export default {
  all,
  items,
  destroy,
  store,
  show,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/client-group/index.js